import { defaultMeta } from '@/constants/defaultMeta';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { mainPageHostListQueries } from '@/services/mainPage/storeList/hostList/hostList.queries';
import { useParams, useSearch } from '@tanstack/react-router';

export const useMainPageHostList = () => {
  const search = useSearch({ from: '/(app)/recommendation-management/main-page/$store-list/$host-list/' });
  const { page, fetch, q } = search;
  const { ['host-list']: clubId } = useParams({
    from: '/(app)/recommendation-management/main-page/$store-list/$host-list/',
  });
  const { data, isFetched, isLoading } = useQuery({
    ...mainPageHostListQueries.list({
      row: page,
      fetch: fetch,
      search: q,
      clubId,
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, search.sort),
    }),
    enabled: !!fetch,
  });

  return {
    mainPageHost: data?.data || [],
    isFetched,
    isLoading,
    pagination: data?.meta?.pagination || defaultMeta,
  };
};
